import { useState } from "react";
import emailjs from "@emailjs/browser";
import React from "react";

const initialState = {
  name: "",
  email: "",
  Mobile: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, Mobile, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setState(initialState);

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_lpqti3v",
        "template_0pv7czc",
        {
          title: "Contact Form Submission",
          name: name,
          email: email,
          mobile: Mobile,
          message: message,
          time: new Date().toLocaleString(),
        },
        "0XRFld87BN6kAGThw"
      )
      .then(
        (result) => {
          console.log("SUCCESS:", result.text);
          clearState();
        },
        (error) => {
          console.log("FAILED:", error.text);
        }
      );
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Name"
                      value={name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-7">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Email"
                      value={email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-7">
                    <input
                      type="tel"
                      name="Mobile"
                      className="form-control"
                      placeholder="Mobile"
                      value={Mobile}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <textarea
                  name="message"
                  className="form-control"
                  rows="4"
                  placeholder="Message"
                  value={message}
                  onChange={handleChange}
                  required
                ></textarea>

                <button type="submit" className="btn btn-custom btn-lg">
                  Send Message
                </button>
              </form>
            </div>
          </div>

          {/* Contact Info */}
          <div className="col-md-3 col-md-offset-1 contact-info">
            <h3>Contact Info</h3>
            <p>{props.data ? props.data.address : "loading"}</p>
            <p>{props.data ? props.data.Mobile : "loading"}</p>
            <p>{props.data ? props.data.email : "loading"}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
